// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__JUwY9","signatureBlock":"Footer_signatureBlock__3gm8B","signature":"Footer_signature__2AIMp"};